'use client'
import { useHomeVideos } from '@/src/queries/home/home-videos'
import VidGrid from '../ui/video-grid'
import React, { useEffect, useState } from 'react'
import { LoadingVideoCard, VideoCard } from '../ui/video-card'
import { Box, Flex, Text } from '@chakra-ui/react'
import { useInView } from 'react-intersection-observer'
import Image from 'next/image'
import { CustomAdBanner } from '@/components/customAdBanner/custom-ad'
import RepeatingAds from '../AdSense/repeatingAds'
import { adBlockerDetected } from '@/src/lib/utils'
import AdBlockerPopup from '../adBlocker/adBlockerPopup'
import { useSidebar } from '@/src/store/sidebar-store'
export default function HomeVideos() {
  const { ref, inView } = useInView()
  const result = useHomeVideos()
  const { isSideBarOpen } = useSidebar()
  const [viewportWidth, setViewportWidth] = useState<number | null>(
    typeof window !== 'undefined' ? window.innerWidth : null
  )
  useEffect(() => {
    const handleResize = () => setViewportWidth(window.innerWidth)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])
  const {
    status,
    data,
    isFetchingNextPage,
    isFetching,
    fetchNextPage,
    hasNextPage,
  } = result
  const hasNextPageRef = React.useRef<boolean>(hasNextPage)
  useEffect(() => {
    hasNextPageRef.current = hasNextPage
  }, [hasNextPage])
  useEffect(() => {
    if (
      inView &&
      hasNextPageRef.current &&
      !isFetchingNextPage &&
      !isFetching
    ) {
      fetchNextPage()
    }
  }, [inView, isFetchingNextPage, fetchNextPage, isFetching])
  let GridContent: React.ReactNode = null
  if (status == 'pending') {
    GridContent = (
      <>
        {Array(5)
          .fill('-')
          .map((_, i) => (
            <LoadingVideoCard key={i} id={i} />
          ))}
      </>
    )
  }
  const cardsPerRow = React.useMemo(() => {
    const w = viewportWidth
    if (w === null) return null
    if (w >= 1920) return isSideBarOpen ? 4 : 5
    if (w >= 1536) return isSideBarOpen ? 3 : 4
    if (w >= 1280) return 4
    if (w >= 992) return 3
    if (w >= 768) return 2
    return 1
  }, [viewportWidth, isSideBarOpen])
  const customAdIndex = cardsPerRow ? cardsPerRow * 2 : null
  const allVideos = data?.pages.flatMap((page) => page.videos) ?? []

  if (allVideos.length === 0 && status == 'success') {
    return (
      <Flex
        w="100%"
        flex="1"
        flexDir="column"
        align="center"
        justify="center"
        mt={40}
      >
        <Image src="/failed.svg" width={150} height={150} alt="Failed Icon" />
        <Text mt={4} color="black" fontWeight={600} fontSize={18}>
          No videos found!
        </Text>
      </Flex>
    )
  }

  if (status == 'success') {
    GridContent = data?.pages.map((page, i) => (
      <React.Fragment key={i}>
        {page.videos.map((video, index) => {
          let currentNo = i * page.videos.length + index + 1
          const shouldShowCustomAd =
            customAdIndex !== null && currentNo === customAdIndex
          return (
            <>
              <VideoCard
                key={video.eventId}
                eventId={video.eventId}
                creatorId={video.channelId}
                videoDuration={video.duration}
                avatarUrl={video.imageUrl}
                creatorName={video.channelName}
                title={video.eventTitle}
                watchTime={video.UniqueWatchTime}
                thumbnailUrl={video.thumbnailImage}
                sharedImageName={video.sharedImageName || video.thumbnailImage}
                timelineUpload={video.eventEntryDate}
                live={video.type == '2' ? 'live' : ''}
                isWatchList={video.isWatchList}
                encryptVideoUrl={video.encryptVideoUrl}
                themeColor={video.themeColor || '#E79051'}
                channelShareName={video.channelShareName || ''}
                isVerifiedTick={video.isVerifiedTick}
                watchCount={video.watchCount || '0'}
                hlsLink={video.hlsLink || ''}
              />
              {shouldShowCustomAd && (
                  <CustomAdBanner />
              )}
              {/* <RepeatingAds currentNo={currentNo} adId="7501795150" /> */}
            </>
          )
        })}
      </React.Fragment>
    ))
  }
  if (status == 'error') {
    return (
      <Flex
        w="100%"
        flex="1"
        flexDir="column"
        align="center"
        justify="center"
        mt={40}
      >
        <Image src="/failed.svg" width={150} height={150} alt="Failed Icon" />
        <Text mt={4} color="black" fontWeight={600} fontSize={18}>
          Failed to load videos!
        </Text>
      </Flex>
    )
  }
  return (
    <Box>
      <Text fontWeight="bold" fontSize="xl" mt={5} mb={3}>
        Discover More...
      </Text>
      <VidGrid>
        {GridContent}
        {isFetchingNextPage &&
          Array(12)
            .fill('-')
            .map((_, i) => <LoadingVideoCard key={i} id={i} />)}
      </VidGrid>
      <div ref={ref} style={{ marginTop: '-300px' }}></div>
      <AdBlockerPopup />
    </Box>
  )
}
